import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">网友热评</h2>
          <p className="text-sm text-foreground-600 mt-3">来看看吃瓜群众们都在聊些什么</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-semibold text-foreground-900">{item.user}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}